export default __webpack_public_path__ + "static/media/avatar.df98114a.png";